// extracted by mini-css-extract-plugin
export default {"col":"BaseSetting_col__yf-Az","checked":"BaseSetting_checked__0ya+j","disabled":"BaseSetting_disabled__-s4Jj"};